import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

// Read the saved choice BEFORE i18next-browser-languagedetector
// writes anything into localStorage — otherwise the detector will
// cache the navigator-detected language ("en") into sug_lang on the
// very first load and our "if no saved choice → Arabic" guard below
// never fires.
const savedLang = typeof window !== "undefined" ? window.localStorage.getItem("sug_lang") : null;
// An explicit ?lang= wins (used by the hreflang alternates so each language
// has a crawlable URL).
const queryLang = typeof window !== "undefined"
  ? new URLSearchParams(window.location.search).get("lang")
  : null;
const requested = queryLang === "en" || queryLang === "ar" ? queryLang : savedLang;
const initialLang = requested === "en" || requested === "ar" ? requested : "ar";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    // Force the resolved value up-front so no navigator detection
    // races the guard we used to have here.
    lng: initialLang,
    fallbackLng: "ar",
    supportedLngs: ["ar", "en"],
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "sug_lang",
    },
    interpolation: { escapeValue: false },
  });

function applyDirection(lng) {
  const dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
}

// Persist the default so subsequent loads are consistent (the
// LanguageSwitcher writes here too when the user picks manually).
if (typeof window !== "undefined" && !savedLang) {
  try { window.localStorage.setItem("sug_lang", "ar"); } catch (_) { /* ignore */ }
}

applyDirection(i18n.resolvedLanguage || i18n.language || "ar");

i18n.on("languageChanged", (lng) => {
  applyDirection(lng);
});

export default i18n;
